<template>
  <div class="pa-5 messages-container">
    <template v-if="loading">
      <div class="text-center p-10">
        <v-progress-circular
          :size="50"
          :width="3"
          color="grey"
          indeterminate
        ></v-progress-circular>
      </div>
    </template>
    <template v-else>
      <div v-for="(message, index) in messages" :key="index">
        <div v-if="message.sender == 'client'" class="message-received">
          <div
            class="subtitle-2"
            v-if="
              !messages[index - 1] || messages[index - 1].sender != 'client'
            "
          >
            <v-icon class="pa-1">
              mdi-account
            </v-icon>
            Cliente
          </div>
          <div class="body-1 pb-1">
            {{ message.message }}
          </div>
          <div class="caption">
            {{ $moment(message.datetime * 1000).format("h:mma DD-MM-YYYY") }}
          </div>
        </div>
        <div v-if="message.sender == 'bot'" class="message-bot">
          <div
            class="subtitle-2"
            v-if="!messages[index - 1] || messages[index - 1].sender != 'bot'"
          >
            Bot
            <v-icon class="pa-1">
              mdi-robot
            </v-icon>
          </div>
          <div class="body-1 pb-1">
            {{ message.message }}
          </div>
          <div class="caption">
            {{ $moment(message.datetime * 1000).format("h:mma DD-MM-YYYY") }}
          </div>
        </div>
        <div v-if="message.sender == 'agent'" class="message-agent">
          <div
            class="subtitle-2"
            v-if="!messages[index - 1] || messages[index - 1].sender != 'agent'"
          >
            Agente
            <v-icon class="pa-1">
              mdi-face-agent
            </v-icon>
          </div>
          <div class="body-1 pb-1">
            {{ message.message }}
          </div>
          <div class="caption">
            {{ $moment(message.datetime * 1000).format("h:mma DD-MM-YYYY") }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { Config } from "../../config";
export default {
  props: {
    id: {
      type: String,
      require: true,
      messages: {}
    }
  },
  data() {
    return {
      loading: true
    };
  },
  watch: {
    messages() {
      this.scrollToBotom();
    }
  },
  computed: {},
  mounted() {
    this.getConversations();
  },
  methods: {
    getConversations() {
      let url = `${Config.url}/db/conversation/messages?sessionId=${this.id}`;
      this.axios.get(url).then(res => {
        this.messages = res.data.conversation;
        this.loading = false;
        setTimeout(() => {}, 1000);
      });
    },
    scrollToBotom() {
      setTimeout(() => {
        this.$refs.down.scrollTop =
          this.$refs.down.scrollHeight - this.$refs.down.clientHeight;
      }, 100);
    }
  }
};
</script>
<style scoped>
.messages-container {
  overflow-y: auto !important;
  max-height: 100% !important;
  background-color: transparent;
}
.message-received {
  padding: 6px !important;
  border-radius: 1px 10px 10px 10px;
  margin: 4px 0px !important;
  max-width: 80%;
  background-color: #e0f2f1;
}
.message-agent {
  padding: 6px !important;
  border-radius: 10px 10px 1px 10px;
  max-width: 80%;
  margin-left: 20%;
  margin-bottom: 4px;
  background-color: #e8f5e9;
  text-align: right;
}
.message-bot {
  padding: 6px !important;
  border-radius: 10px 10px 1px 10px;
  max-width: 80%;
  margin-left: 20%;
  margin-bottom: 4px;
  background-color: #e8f5e9;
  text-align: right;
}
.modal-show-mesages {
  width: 480px !important;
  height: 100% !important;
  border-radius: 10px !important;
  background-color: #78909c;
}
.message-time {
  font-size: 10px;
  font-style: italic;
}
.message-text {
  display: block;
  margin-block-start: 0em;
  margin-block-end: 0em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.messages-container::-webkit-scrollbar {
  -webkit-appearance: none;
}
.messages-container::-webkit-scrollbar:vertical {
  width: 10px;
}
.messages-container::-webkit-scrollbar-thumb {
  background-color: #aaaaaa;
  border-radius: 20px;
  border: 1px solid #f1f2f3;
}
.message-from {
  font-size: 10px;
  font-weight: bold;
}
.message-avatar {
  border-radius: 50%;
  border: 2px solid red;
  max-width: 15px;
  max-height: 15px;
}
</style>
